
import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import HomeReportActions, { HomeReportRedux, HomeReportTypes } from '../../Redux/ParentPlatform/HomeReportRedux'
import { notificationFail, notificationSuccess } from '../../Redux/NotificationActions'

const homeReportCrudObservable = createCRUDObservable({
  mainRedux: HomeReportRedux,
  reduxPath: 'home_report',
})

const postHomeReportEpic = (action$, store, { Api }) => (
  action$.ofType(HomeReportTypes.postHomeReportRequest)
    .mergeMap(({ studentId, data }) => (
      Observable
        .fromPromise(Api.home_report.postHomeReport(studentId, data)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              HomeReportActions.postHomeReportError(response.error),
              notificationFail(response.error),
            ]
          }

          return [
            HomeReportActions.postHomeReportSuccess(response),
            notificationSuccess('Se ha registrado correctamente el formato de entrada.'),
          ]
        })
    ))
)
const getHomeReportStudentEpic = (action$, store, { Api }) => (
  action$.ofType(HomeReportTypes.getHomeReportStudentRequest)
    .mergeMap(({ studentId }) => (
      Observable
        .fromPromise(Api.home_report.getHomeReportStudent(studentId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              HomeReportActions.getHomeReportStudentError(response.error),
              notificationFail(response.error),
            ]
          }
          const data  = response.data.data !== null ? response.data.data :[]
          return [
            HomeReportActions.getHomeReportStudentSuccess(data),
            // notificationSuccess('Se ha registrado correctamente el formato de entrada.'),
          ]
        })
    ))
)

export const HomeReportObservers = Object.assign({}, homeReportCrudObservable.observers, {})

export const HomeReportEpic = combineEpics(
  homeReportCrudObservable.epic,
  postHomeReportEpic,
  getHomeReportStudentEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/HomeReportObservable.js